import styled from "styled-components";
import BaseButton from "../../../common/Button";

export const Container = styled.div`
  width: 100%;
  max-width: 873px;
  margin: 40px auto;
  padding: 0 20px;

  @media (max-width: 767px) {
    margin: 20px 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 30px;

  @media (max-width: 570px) {
    margin: 20px 0;
  }

  @media (max-width: 570px) {
    flex-direction: column;
  }
`;

export const Logo = styled.div`
  @media (max-width: 570px) {
    margin-bottom: 20px;
  }

  svg {
    width: 200px;
    height: 26px;
    fill: ${({ theme }) => theme.colors.suite[900]};
  }
`;

export const MLS = styled.h3`
  font-size: 18px;
  line-height: 24px;
`;

export const Well = styled.div`
  padding: 35px;
  background-color: ${({ theme }) => theme.colors.gray[200]};
  border: 1px solid ${({ theme }) => theme.colors.gray[500]};
  border-radius: 12px;

  @media (max-width: 767px) {
    padding: 35px;
  }
`;

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 500;
  line-height: 41px;
  margin-bottom: 14px;
  color: ${({ theme }) => theme.colors.suite[900]};
  text-align: center;
`;

export const Text = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  margin: 0 0 30px;
  color: ${({ theme }) => theme.colors.gray[700]};
  text-align: center;
`;

export const Grid = styled.div`
  display: flex;
  margin: -25px;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const Cell = styled.div`
  width: 50%;
  padding: 25px;

  @media (max-width: 767px) {
    width: 100%;
    padding: 15px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Label = styled.label`
  display: flex;
  align-items: baseline;
  font-size: 15px;
  margin-bottom: 10px;
  cursor: pointer;
`;

export const LabelError = styled.span`
  font-size: 13px;
  margin-left: auto;
  color: #e53a40;
`;

export const LoginOptions = styled.div`
  font-size: 13px;
  line-height: 16px;
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.gray[700]};
`;

export const LoginOption = styled.a`
  color: ${({ theme }) => theme.colors.suite[500]};
  text-decoration: underline;
`;

export const Activate = styled(BaseButton)`
  width: 100%;
  margin-top: 22px;
`;

export const Loading = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
`;

export const Error = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  margin: 30px 0 0;
  color: ${({ theme }) => theme.colors.accent.red};
  text-align: center;
`;

export const TOSText = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray[800]};

  a {
    color: ${({ theme }) => theme.colors.suite[500]};
    text-decoration: underline;
  }
`;
